import React, { useEffect, useState } from "react";
import "./styles.scss";
// import "./mobile.scss";
import {
  Button,
  FilterColor,
  FormHeader,
  InputBox,
  MenuItem,
  RadioButton,
  TopMenu,
} from "../../components";
import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { CheckValidity } from "../../utils/formValidity";
import { useDispatch } from "react-redux";
import { authentication } from "./service/auth.service";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { login, userDetails } from "../../utils/auth";
import { getLanguage, toggleLanguage } from "../../utils";

const lan = getLanguage();

const SignInComponent = (props) => {
  const dispatch = useDispatch();

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    userName: {
      key: "userName",
      label: "Title (EN)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    password: {
      key: "password",
      label: "Password",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "password",
        placeholder: "**********",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const handleChange = async (event, inputIdentity) => {
    const updateNewProductForm = {
      ...formData,
    };

    updateNewProductForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewProductForm[inputIdentity].value,
      updateNewProductForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewProductForm[inputIdentity].isValid = validityRes.isValid;
      updateNewProductForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewProductForm[inputIdentity].value = event;
      updateNewProductForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewProductForm) {
        formIsValid =
          updateNewProductForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewProductForm);
    }
  };

  //update input validation
  const updateInputValidationErrors = async () => {
    let df = { ...formData };
    let formIsValid = true;
    for (let itemKey of Object.keys(df)) {
      if (itemKey === "firstName" || itemKey === "firstName") {
        if (df[itemKey].value === "" || df[itemKey].invalidReason) {
          df[itemKey].touched = true;
          formIsValid = false;
        }
      }
    }
    await setFormData(df);
    return formIsValid;
  };

  const onClickSave = async (e) => {
    setIsLoading(true);
    const updateNewProductForm = {
      ...formData,
    };
    let result = await authentication({
      username: updateNewProductForm.userName.value,
      password: updateNewProductForm.password.value,
    });
    console.log("result", result);
    if (result.data?.status) {
      login(result?.data?.token);
      console.log("login Token", result.data.token);
      const user = userDetails();
      console.log("user", user);
      Store.addNotification({
        title: "Wonderful!",
        message: "Successfully Login!",
        type: "success",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      setIsLoading(false);
      props.history.push("/admin");
    } else {
      Store.addNotification({
        title: "Error!",
        message: "Login Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  // const dispatch = useDispatch();
  const updateNewProductForm = { ...formData };

  return (
    <>
      <div className={"sign-in-wrapper"}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: false,
              isProfile: false,
            }}
          />
        </div>
        <div className={"siw__form"}>
          <div className={"siwf__header-wrapper"}>
            <div className={"siwf__hw-logo"}>
              <img src={require("../../assets/img/lgo.png")} alt={"logo"} />
            </div>
            <FormHeader
              data={{
                formHeader: "LOG IN",
                size: "md x",
              }}
            />
          </div>
          <InputBox
            data={updateNewProductForm.userName}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(
                e.target.value,
                updateNewProductForm.userName.key
              );
            }}
          />
          <InputBox
            data={updateNewProductForm.password}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(
                e.target.value,
                updateNewProductForm.password.key
              );
            }}
          />
          <div className={"cw__language"}>
            Choose preference language{" "}
            <div className="d-flex flex-row" style={{ gap: "10px" }}>
              <RadioButton
                data={{
                  name: "English",
                  isActive: lan === "en",
                }}
                onClick={() => {
                  toggleLanguage();
                }}
              />
              <RadioButton
                data={{
                  name: "සිංහල",
                  isActive: lan === "si",
                }}
                onClick={() => {
                  toggleLanguage();
                }}
              />
              {/* <span className={`cw__english ${lan === "en" ? "active" : ""}`}>
                English
              </span>{" "}
              |{" "}
              <span className={`cw__sinhala ${lan === "si" ? "active" : ""}`}>
                සිංහල
              </span> */}
            </div>
          </div>
          <Button
            data={{
              btnName: "Login",
              buttonType:
                updateNewProductForm.userName.value === "" ||
                updateNewProductForm.password.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
            }}
            onClick={async (e) => {
              e.preventDefault();
              await onClickSave(e);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(SignInComponent);
